import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useModuleVisibility } from "../hooks/useModuleVisibility";

/**
 * Guard di visibilità per le route della dashboard: se la pagina (o il suo
 * modulo sidebar) è disabilitata dalla config module-visibility, redirige al
 * profilo (sempre visibile, non gate-abile). Gate "hard": protegge anche
 * l'accesso per URL diretto, non solo il nascondiglio in sidebar.
 */
export const ModuleVisibilityGuard: FC<{
  /** chiave pagina (flag "fe:<pageKey>") — vedi module-visibility/seed-default.json */
  pageKey: string;
  /** chiave del modulo sidebar di appartenenza (flag "fe:<moduleKey>") */
  moduleKey?: string;
  children: ReactNode;
}> = ({ pageKey, moduleKey, children }) => {
  const { isVisible } = useModuleVisibility();

  const hidden =
    !isVisible(pageKey) || (moduleKey ? !isVisible(moduleKey) : false);

  if (hidden) return <Navigate to="/dashboard/profile" replace />;
  return <>{children}</>;
};
